<template>
    <div>
        <div id="mygalModal" aria-hidden="true" class="modal fade move-up in intro-modal modal-for-gal" style="display: block; z-index: 9999;">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="new-modal">
                        <div class="modal_down bacground_sdo">
                            <div class="intro-modal-body">
                                <div class="trial-details">
                                    <div class="preview" style="padding-top: 35px !important;display:flex;justify-content: center;">
                                        <span style="font-size: 18px;">Send a Message to Your Doctor.</span>
                                    </div>
                                    <div class="preview" style="padding-top: 35px !important;display:flex;justify-content: center; width: 100%;">
                                        <span style="font-size: 20px;width: 95%;">
                                            <textarea rows="5" v-model="message" class="textarea w-input"></textarea>
                                        </span>
                                    </div>
                                    <div class="footer-button" style="padding-top: 35px !important;">
                                    <div class="div-block-1120">
                                        <a href="#" @click="sendMEssage($event)" class="button-44 w-button dash-button" style="color:#fff">
                                            <span v-if="submitted"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: none; display: block; shape-rendering: auto;" width="15px" height="15px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                                                    <circle cx="50" cy="50" fill="none" stroke="blue" stroke-width="10" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">
                                                        <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.53475935828877s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
                                                    </circle>
                                                </svg></span>
                                            <span v-else>Send Message</span></a>
                                        <a href="#" @click="CloseDialog($event)" class="button-45 w-button dash-button">Cancel</a>
                                    </div>
                                </div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </template>
    
    <script>
    export default {
        props: ["textP"],
        data() {
            return {
                mykey: 1,
                message: '',
            }
        },
        mounted() {
    
        },
        methods: {
            sendMEssage(){
                if(this.message.trim()!=''){
                    this.$emit('submitMessage',this.message)
                }
            },
            CloseDialog(event) {
                event.preventDefault();
                this.$emit("CloseBox");
            },
        },
        created() {
            
        }
    }
    </script>
    
    <style scoped>
    .modal {
        display: none;
        position: fixed;
        z-index: 1;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        overflow: auto;
        background-color: rgb(0, 0, 0);
        background-color: rgba(0, 0, 0, 0.4);
    
    }
    
    .intro-modal-body {
        justify-content: center;
    }
    
    .intro-modal-heading {
        font-size: 18px;
        display: flex;
        justify-content: center;
    }
    
    .modal-content {
        background-color: #fefefe;
        border-radius: 10px;
        max-width: 468px;
        margin: 15% auto;
        padding: 20px;
        border: 1px solid #888;
        width: 80%;
    }
    
    .dash-button {
        height: 45px;
    }
    
    .options-container {
        display: flex;
        flex-wrap: wrap;
    }
    </style>
    